import { rankings } from '@/mocks/homeMangaData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门排行</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">综合阅读量、收藏数与讨论热度的实时热门漫画排行</p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 rounded-xl p-4 md:p-5 group hover:bg-background-200/50 transition-colors cursor-pointer"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg font-heading text-lg font-bold flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-secondary-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-300 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">{item.genre}</span>
                </div>
                <p className="text-xs text-foreground-500">{item.author}</p>
                <p className="text-sm text-foreground-600 mt-1 leading-snug">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 text-right">
                <p className="font-heading text-lg font-bold text-primary-600">{item.score}</p>
                <p className="text-xs text-foreground-400">评分</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}